import InputFeedback from './InputFeedback';

export default InputFeedback;
